import { render, staticRenderFns } from "./ActivityCreateUpdate.vue?vue&type=template&id=93231de4&"
import script from "./ActivityCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./ActivityCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports